<template>
  <button
    type="button"
    :class="`${$attrs.class || 'button-gray'} btn${!hasDefaultSlot ? ' justify-center' : ''}`"
    :disabled="loading || disabled"
  >
    <SpiningCircleIcon
      v-if="loading"
      :class="[iconSizeClass, { 'text-[#FDF2F2]/50 fill-red-50': props.variant === 'danger' }]"
    />
    <slot v-else name="start-adornment" />
    <span class="btn-label truncate" :class="{ 'flex-grow': hasDefaultSlot }"><slot /></span>
    <slot name="end-adornment" />
  </button>
</template>
<script setup lang="ts">
import SpiningCircleIcon from './icons/SpiningCircleIcon.vue';
import { TButtonVariant, TIconSize } from '@/components/Button.type';
import { computed, useSlots } from 'vue';

const slots = useSlots();
const hasDefaultSlot = computed(() => typeof slots.default === 'function');

const props = withDefaults(
  defineProps<{
    loading?: boolean;
    disabled?: boolean;
    variant?: TButtonVariant;
    iconSize?: TIconSize;
  }>(),
  {
    loading: false,
    disabled: false,
    variant: 'primary',
    iconSize: 'small',
  },
);

const iconSizeClass = computed(() => {
  switch (props.iconSize) {
    case 'small':
      return 'w-4 h-4';
    case 'medium':
      return 'w-5 h-5';
    case 'large':
      return 'w-6 h-6';
    default:
      return 'w-4 h-4';
  }
});
</script>
<style scoped>
.btn:disabled {
  cursor: not-allowed;
  @apply text-text-disabled;
}
</style>
